import React from 'react';

export default function Text( props ) {
	return (
		<>
		<div dangerouslySetInnerHTML={{ __html: props.content.text }}/>
		</>
	);
}